import { ENV } from "../utils";

export class WorkProcess {
  baseApi = ENV.BASE_API;

  async getWorkProcesses(active) {
    const url = active !== undefined
      ? `${this.baseApi}/work-processes?active=${active}`
      : `${this.baseApi}/work-processes`;
    const params = { method: "GET", headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("access")}` } };
    const res = await fetch(url, params);
    const result = await res.json();
    if (res.status !== 200) throw result;
    return result;
  }

  async createWorkProcess(data) {
    const url = `${this.baseApi}/add-work-process`;
    const params = { method: "POST", headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("access")}` }, body: JSON.stringify(data) };
    const res = await fetch(url, params);
    const result = await res.json();
    if (res.status !== 200) throw result;
    return result;
  }

  async updateWorkProcess(id, data) {
    const url = `${this.baseApi}/update-work-process/${id}`;
    const params = { method: "PUT", headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("access")}` }, body: JSON.stringify(data) };
    const res = await fetch(url, params);
    const result = await res.json();
    if (res.status !== 200) throw result;
    return result;
  }

  async deleteWorkProcess(id) {
    const url = `${this.baseApi}/delete-work-process/${id}`;
    const params = { method: "DELETE", headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("access")}` } };
    const res = await fetch(url, params);
    const result = await res.json();
    if (res.status !== 200) throw result;
    return result;
  }
}
